"use client";

import {createContext} from "react";

export type CarouselContextValue = {
	activeIndex: number;
	setActiveIndex: (index: number) => void;
	goToPrevious: () => void;
	goToNext: () => void;
	hasPrevious: boolean;
	hasNext: boolean;
};

export const CarouselContext = createContext<CarouselContextValue>({
	activeIndex: 0,
	setActiveIndex: () => {},
	goToPrevious: () => {},
	goToNext: () => {},
	hasPrevious: false,
	hasNext: false,
});
